// Staff originals use their versioned editor. Ordinary rows retain the existing
// dashboard edit request, including its responsive editor routing.
export const requestTimelineEntryEdit = ({
  entry,
  entryConfig,
  entryId,
  onEditEntry,
  onEditOriginal,
}) => {
  if (onEditOriginal) {
    onEditOriginal();
    return;
  }
  if (typeof window !== "undefined" && entry) {
    window.dispatchEvent(
      new CustomEvent("captureez:timeline-edit-request", {
        detail: { entry, entryConfig, entryId },
      }),
    );
    return;
  }
  onEditEntry?.(entry, entryConfig);
};
